import { connect, MapDispatchToProps, MapStateToProps } from 'react-redux';
import { Url } from '@wix/da-url';
import { pushModal } from '@wix/da-shared-react/pkg/Modals/redux/basicActions';
import { ModalType } from '@wix/da-shared-react/pkg/Modals/redux/types';
import { getCurrentUser } from '@wix/da-shared-react/pkg/publicSession/selectors';
import { addBookmark, removeBookmark } from '@wix/da-submit-shared/pkg/redux/actions';
import { confirmDeleteFolder, moveFolderUp, copyFolderLink } from '../../../actions/studio/folders';
import { getFeaturedFolderId } from '../../../selectors/studio';
import { Props } from './FolderActionsDropdown';

export type StateProps = Pick<Props, 'currentUser' | 'featuredFolderId'>;
export type DispatchProps = Pick<
  Props,
  | 'onCreateClick'
  | 'onEditClick'
  | 'onShareClick'
  | 'onMoveUpClick'
  | 'onDeleteClick'
  | 'onBookmarkAddClick'
  | 'onBookmarkRemoveClick'
>;
export type OwnProps = Omit<Props, keyof (StateProps & DispatchProps)>;

const mapStateToProps: MapStateToProps<StateProps, OwnProps, any> = (state, props) => ({
  currentUser: getCurrentUser(state),
  featuredFolderId: getFeaturedFolderId(state),
});

const mapDispatchToProps: MapDispatchToProps<DispatchProps, OwnProps> = (dispatch, { folder }) => ({
  onCreateClick: () =>
    dispatch(
      pushModal(ModalType.STUDIO_FOLDER, {
        params: { folderType: folder.type },
      })
    ),

  onEditClick: () =>
    dispatch(
      pushModal(ModalType.STUDIO_FOLDER, {
        params: { folderId: folder.folderId, folderType: folder.type },
      })
    ),

  onBookmarkAddClick: () => dispatch(addBookmark(folder)),
  onBookmarkRemoveClick: () => dispatch(removeBookmark(folder)),

  onShareClick: () => dispatch(copyFolderLink(folder)),

  onMoveUpClick: () => dispatch(moveFolderUp(folder)),

  onDeleteClick: () =>
    dispatch(
      confirmDeleteFolder(folder, () => {
        window.location.assign(
          folder.type === 'stash'
            ? Url.studioStash(folder.parentId || undefined)
            : Url.studioGallery(folder.parentId || undefined)
        );
      })
    ),
});

export default connect(mapStateToProps, mapDispatchToProps);
